import React from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import { ReactComponent as Background } from '../../assets/images/background.svg';

export const getBackgroundURL = (color?: string) => {
  const svgString = encodeURIComponent(renderToStaticMarkup(<Background />));
  const circleColor = color ? color.slice(1) : '5889FF';
  return `url("data:image/svg+xml,${svgString.replace(/5889FF/g, circleColor)}")`;
};
